import { log } from './logging';
import isEmpty from 'lodash.isempty';

import { AGREE_OPTIONS, USER_ID } from '../constants';

export const getUserId = () => localStorage.getItem(USER_ID)

export const getAgreementLabel = (key) => {
	let needle = AGREE_OPTIONS.find( o => o.value === key );
	return needle ? needle.label : '';
}



export const shuffle = (arr) => {
	let i, temp, j, len = arr.length;
	for (i = 0; i < len; i++) {
		j = ~~(Math.random() * len);
		temp = arr[i];
		arr[i] = arr[j];
		arr[j] = temp;
	}
	return arr;
}

const largestRemainderRound = (numbers, desiredTotal) => {
  let result = numbers.map( (number, index) => ({ 
  	floor: Math.floor(number),
  	remainder: getRemainder(number),
  	index: index,
  }))
  .sort( (a, b) => b.remainder - a.remainder )

  let lowerSum = result.reduce( (sum, current) => sum + current.floor, 0);

  let delta = desiredTotal - lowerSum;
  for (let i = 0; i < delta; i++) {
    result[i].floor += 1;
  }
  return result.sort( (a, b) => a.index - b.index ).map( result => result.floor )
}

const getRemainder = (number) => {
  let remainder = number - Math.floor(number);
  return remainder.toFixed(4);
}

export const processData = (question, data) => {

	if(isEmpty(data)) return;

	let total = data['total'];
	delete data['total'];

	let parsedData = Object.keys(data).reduce( (acc, key) => {
		let label;
		try {
			// laziness
			if('agree' in data) {
				label = getAgreementLabel(key);
			} else {
				label = question.options.find( option => option.value === key ).label;
			}
		} catch(err) {
			log(`no label found for question:${question.id}, key:${key}`);
		}
		acc.push({
			name: key,
			value: total > 0 ? data[key] / total * 100 : 0,
			label
		});
		return acc;
	}, []);

	// ensure we dont go over 100%!
	let percents = largestRemainderRound( parsedData.map( point => point.value ), 100 );
	parsedData = parsedData.map( (point, index) => ({ ...point, value: percents[index] }) )

	if(question.sortOrder) {
		log('we has sortOrder', question.sortOrder);
		let sortedData = [];
		let order = question.sortOrder.slice();
		while(order.length) {
			sortedData.push(parsedData.find( point => point.name === order[0] ))
			order.shift();
		}
		log('sortedData', sortedData);
		return sortedData;
	}
	return parsedData;
}


// WEBPACK FOOTER //
// ./utils/index.js